/**
 * Listele de valori se copiază din `schema.prisma`, niciodată din memorie.
 * Categoriile plauzibile scrise din cap au fost respinse de server cu 400, iar
 * suita n-avea cum să le prindă: ea nu trece prin dropdownuri.
 *
 * Etichetele stau tot aici: o enumerare scursă brută pe ecran („SA",
 * „AsteaptaAprobareDeviz") nu e o propoziție pentru nimeni.
 */

import { tr } from "./i18n.js";

export const FRECVENTE = {
  D: "zilnic",
  W: "săptămânal",
  M: "lunar",
  Q: "trimestrial",
  SA: "semestrial",
  A: "anual",
};

export const REZULTATE = {
  Conform: "conform",
  Neconform: "neconform",
  NA: "nu se aplică",
  RemediatPeLoc: "remediat pe loc",
};

export const SEVERITATI = {
  Critic: "critic",
  Major: "major",
  Important: "important",
  Minor: "minor",
};

export const MOTIVE_BLOCARE = {
  AsteaptaPiesa: "așteaptă piesa",
  AsteaptaAprobareDeviz: "așteaptă aprobarea devizului",
  AsteaptaAccesLaClient: "așteaptă acces la client",
  AsteaptaBugetClient: "așteaptă bugetul clientului",
  NecesitaRevenire: "necesită revenire",
  AsteaptaSubcontractor: "așteaptă subcontractorul",
};

/** Care blocaje sunt ale clientului — ele îi devin vizibile implicit. */
export const BLOCAJE_ALE_CLIENTULUI = [
  "AsteaptaAprobareDeviz", "AsteaptaAccesLaClient", "AsteaptaBugetClient",
];

export const STARI_RESTANTA = {
  Deschisa: "deschisă",
  Planificata: "planificată",
  Rezolvata: "rezolvată",
  Anulata: "anulată",
};

export const SURSE_RESTANTA = {
  Checklist: "checklist de mentenanță",
  FisaInterventie: "fișă de intervenție",
  Tichet: "tichet",
  Manual: "deschisă manual",
};

/**
 * Etichetele astea stăteau într-un singur ecran (Intervenții), deci celelalte
 * n-aveau de unde să le ia — și scurgeau valoarea brută: „InDeplasare" într-un
 * tichet, „Incheiat" într-o listă de clienți, „Propusa" pe o propunere de
 * vizită. Aceeași greșeală ca `um()`, care trăia în ecranul de catalog.
 */
export const STARI_VIZITA = {
  Programata: "Programată", InDeplasare: "În deplasare", InExecutie: "În execuție",
  Suspendata: "Suspendată", Finalizata: "Finalizată", Anulata: "Anulată",
  Ciorna: "Ciornă", TrimisaSpreValidare: "Trimisă spre validare",
  AsteaptaAprobare: "Așteaptă aprobarea devizului",
  Validata: "Validată", Semnata: "Semnată", Stornata: "Stornată",
};

export const STATUT_CLIENT = {
  Prospect: "prospect", Activ: "activ", Suspendat: "suspendat", Incheiat: "încheiat",
};

export const STATUT_TEHNICIAN = {
  Activ: "activ", Suspendat: "suspendat", Plecat: "plecat",
};

/** De unde a ajuns echipamentul în parc — nu e o etichetă de stare, e o proveniență. */
export const SURSA_ECHIPAMENT = {
  Import: "import", Interventie: "intervenție", Manual: "adăugat manual",
};

export const STARI_PROPUNERE = {
  Propusa: "propusă", Acceptata: "acceptată", Refuzata: "refuzată", Expirata: "expirată",
};

/**
 * Modelul de mentenanță preventivă din contractul comercial.
 * `Nedeclarat` nu se poate alege — e valoarea contractelor dinaintea câmpului.
 */
export const REGIMURI_PREVENTIV = {
  FaraPreventiv: "fără preventiv — clientul își asumă",
  InclusInAbonament: "inclus în abonament, N cicluri pe an",
  LaCerere: "se face la cerere și se facturează",
};

export const REGIM_PREVENTIV_TOATE = {
  Nedeclarat: "nedeclarat",
  ...REGIMURI_PREVENTIV,
};

/** MT26 — contorul de abonament. */
export const TIPURI_PACHET = {
  Vizite: "vizite",
  OreManopera: "ore de manoperă",
  Valoare: "valoare",
  Interventii: "intervenții",
};

export const PERIOADE_PACHET = {
  Lunar: "lunar",
  Trimestrial: "trimestrial",
  Anual: "anual",
  PeDurataContractului: "pe toată durata contractului",
};

/** MT14 — garanții și returi. */
export const TIPURI_GARANTIE = {
  Producator: "de producător",
  Instalator: "de instalator",
  Extinsa: "extinsă",
};

export const STARI_RMA = {
  Deschis: "pregătit",
  Trimis: "trimis la furnizor",
  Acceptat: "acceptat de furnizor",
  Respins: "refuzat de furnizor",
  Revenit: "revenit",
  Anulat: "anulat",
};

export const REZULTATE_RMA = {
  Reparat: "reparat",
  Inlocuit: "înlocuit",
  RespinsDeFurnizor: "refuzat de furnizor",
  Nerezolvat: "nerezolvat",
};

/**
 * Eticheta se traduce AICI, la citire — niciodată la definiția hărții.
 *
 * `export const STARI = { Deschisa: tr("deschisă") }` s-ar evalua o singură
 * dată, la încărcarea modulului, deci ar îngheța limba de atunci: comutatorul
 * ar schimba tot ecranul în afară de etichetele de stare. Aceeași regulă
 * pentru orice hartă de etichete din aplicație.
 */
export const eticheta = (harta, v) => tr(harta[v] ?? v);

/**
 * Stările tichetului și ceasurile lui trăiau într-un singur ecran (Tichete),
 * deci orice ecran nou le scurgea brute — „VizitaPropusa" nu e o propoziție.
 * Aceeași familie cu `STARI_VIZITA` de mai sus și cu `um()` de la catalog:
 * mutate aici la primul al doilea consumator, portalul clientului.
 */
export const STARI_TICHET = {
  Deschis: "Deschis", Preluat: "Preluat", VizitaPropusa: "Vizită propusă",
  VizitaAcceptata: "Vizită acceptată", Programat: "Programat",
  InExecutie: "În execuție", Restaurat: "Restaurat", Rezolvat: "Rezolvat",
  Inchis: "Închis", Respins: "Respins", Anulat: "Anulat",
};

export const CEASURI_SLA = { Reactie: "Reacție", Restaurare: "Restaurare" };

export const TIPURI_TICHET = { Incident: "incident", Cerinta: "cerință" };

export const CATEGORII_INTERVENTIE = {
  PIF: "punere în funcțiune", Reparatie: "reparație", Scoatere: "scoatere din funcțiune",
  Extindere: "extindere", Mentenanta: "mentenanță preventivă",
};

export const STARI_SISTEM = {
  Functional: "funcțional", Degradat: "degradat",
  Nefunctional: "nefuncțional", ScosDinFunctiune: "scos din funcțiune",
};

export const CRITICITATI = {
  Scazuta: "scăzută", Medie: "medie", Ridicata: "ridicată", Critica: "critică",
};

export const STARI_LA_PLECARE = {
  Functional: "funcțional", FunctionalCuLimitari: "funcțional, cu limitări",
  NefunctionalNecesitaRevenire: "nefuncțional — necesită revenire",
};

export const ACTIUNI_DEFECT = {
  Reparat: "reparat", Inlocuit: "înlocuit",
  RamaneDefect: "rămâne defect", TrimisInRMA: "trimis în RMA",
};

/** Cine plătește o linie de fișă. */
export const MODURI_ACOPERIRE = {
  Garantie: "în garanție", InclusInContract: "inclus în contract", Facturabil: "facturabil",
};

// ── Registrul de conformitate (MT28) ──────────────────────────────────────
/** De unde vine obligația. Cine o scrie își asumă și încadrarea. */
export const SURSE_OBLIGATIE = {
  Lege: "lege sau normativ", StandardTehnic: "standard tehnic",
  ContractClient: "contract cu clientul", CerintaAsigurator: "cerință a asigurătorului",
  PoliticaInterna: "politică internă",
};

/** Pe ce se aplică — și, implicit, pe ce obiecte se nasc scadențele. */
export const OBIECTE_OBLIGATIE = {
  FirmaPrestatoare: "firma prestatoare", Tehnician: "tehnician",
  ClientObiectiv: "client / obiectiv", SistemInstalat: "sistem instalat",
};

export const STARI_CONFORMITATE = {
  Conform: "conform", ScadentCurand: "scadent curând",
  Neconform: "neconform", Nedeterminat: "nedeterminat",
};

export const DESTINATII_DOSAR = {
  Control: "control al autorității", Client: "audit al clientului",
  Audit: "audit extern", Intern: "uz intern",
};

/**
 * Numele rolurilor, așa cum se citesc pe ecran. Trăiau într-un singur ecran
 * (Utilizatori); la al doilea consumator se mută aici, ca peste tot pe
 * proiect — două copii ale aceleiași liste ajung să nu mai arate la fel.
 */
export const ROLURI = {
  ADMIN_TENANT: "Administrator", MANAGER_TEHNIC: "Manager tehnic", DISPECER: "Dispecer",
  COORDONATOR: "Coordonator", TEHNICIAN: "Tehnician", MAGAZIONER: "Magazioner",
  FINANCIAR: "Financiar", AUDITOR: "Auditor", CLIENT_ADMIN: "Client — administrator",
  CLIENT_UTILIZATOR: "Client — utilizator", CLIENT_FINANCIAR: "Client — financiar",
};

/** Felurile de fotografie de pe fișă (`TipFoto` din schemă). */
export const TIPURI_FOTO = {
  Inainte: "înainte", Dupa: "după", Defect: "defect",
  Serie: "serie", Altele: "altele",
};

/**
 * Starea unui preț negociat cu un client. Un rând în așteptare e scris, dar
 * INERT: nu-l vede rezolvarea de preț, deci ofertele și fișele merg mai departe
 * pe prețul de dinainte.
 */
export const STARI_PRET_NEGOCIAT = {
  Activ: "în vigoare",
  AsteaptaAprobare: "așteaptă aprobare",
  Respins: "respins",
};
